var _rect, _rect2, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCh(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 16,
    viewBox: "0 0 24 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 16,
    rx: 2,
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_239_33504",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 16
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 16,
    rx: 2,
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_239_33504)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 16,
    fill: "#FF0000"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.2855 9.60001H7.19027C7.00617 9.60001 6.85693 9.45077 6.85693 9.26668V6.73335C6.85693 6.54925 7.00617 6.40001 7.19027 6.40001H10.2855V3.53335C10.2855 3.34925 10.4347 3.20001 10.6188 3.20001H13.3807C13.5648 3.20001 13.7141 3.34925 13.7141 3.53335V6.40001H16.8093C16.9934 6.40001 17.1426 6.54925 17.1426 6.73335V9.26668C17.1426 9.45077 16.9934 9.60001 16.8093 9.60001H13.7141V12.4667C13.7141 12.6508 13.5648 12.8 13.3807 12.8H10.6188C10.4347 12.8 10.2855 12.6508 10.2855 12.4667V9.60001Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCh);
export default __webpack_public_path__ + "static/media/CH.89a39fc5c728d83a8086cf540ecd1d01.svg";
export { ForwardRef as ReactComponent };